export default function LoadingScreen({ text = "Cargando…" }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="loading-screen">
      <img src="/mori-logo.jpg" alt="Mori" className="h-12 w-12 rounded-xl object-cover animate-pulse" />
      <p className="text-muted-foreground text-sm font-mono tracking-wide">{text}</p>
    </div>
  );
}
